import { BUS_EVENTS } from 'shared/constants/busEvents';
import { emitter } from 'shared/helpers/mitt';

export const useEditorImage = attachment => {
  // Заглушка
  function getStubDataUrl() {
    return 'data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20width=%22800%22%20height=%22800%22%3E%3Crect%20width=%22800%22%20height=%22800%22%20fill=%22%235BD58A%22/%3E%3C/svg%3E';
  }

  async function urlToDataURL(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.status}`);
      }
      const blob = await response.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.warn('[stub] urlToDataURL failed, using fallback:', error);
      return getStubDataUrl();
    }
  }

  const handlerEditImage = async () => {
    if (!attachment.value) return;
    const file = await urlToDataURL(attachment.value.thumbUrl);
    if (file)
      emitter.emit(BUS_EVENTS.OPEN_IMAGE_EDITOR, {
        attachment: { thumb: file },
        itemIndex: null,
      });
  };

  return { handlerEditImage };
};
